<template>
    <base-box>
        <template #content>
            <div class="g-flex g-items-center" data-testid="affiliate-link-display">
                <div class="g-mr-5">
                    <g-image-thumbnail
                        :background-blur="false"
                        :image-description="title"
                        :image-width="75"
                        :image-height="75"
                        :image-link="imageUrl"
                    />
                </div>
                <div class="g-flex-1">
                    <g-typography tag="p" :value="title" font-weight="semibold" class="g-break-all g-mb-5" />
                    <g-level vertical-align="top">
                        <g-level-item class="g-mr-5">
                            <g-typography tag="p" :value="shortUrl" class="g-break-all" size="small" color="grey-6" />
                        </g-level-item>
                        <template #right>
                            <g-level-item>
                                <g-copy-button
                                    icon="copy"
                                    :copy-text="shortUrl"
                                    theme="live"
                                    size="small"
                                    @click="fireClickEvent"
                                >
                                    Copy
                                </g-copy-button>
                            </g-level-item>
                        </template>
                    </g-level>
                </div>
            </div>
        </template>
    </base-box>
</template>

<script>
    import { computed } from 'vue-demi';
    import { useContactStore } from '../../../../../stores';
    import useEventTracking from '../../../../../src/composables/use-event-tracking';
    import { EVENT_COPY_AFFILIATE_LINK } from '../../../../constants/analytics-events';

    export default {
        name: 'AffiliateLinkDisplay',
        props: {
            link: {
                type: Object,
                required: true
            }
        },
        setup(props) {
            const title = computed(() => {
                return props.link?.context?.title || props.link.original_url;
            });

            const shortUrl = computed(() => {
                return props.link.short_url;
            });

            const imageUrl = computed(() => {
                return props.link?.context?.image || '';
            });

            const contact = useContactStore().data;
            const eventTracking = useEventTracking();

            const fireClickEvent = () => {
                eventTracking.trackEvent(EVENT_COPY_AFFILIATE_LINK, {
                    contact_id: contact?.id
                });
            };

            return {
                title,
                shortUrl,
                imageUrl,
                fireClickEvent
            };
        }
    };
</script>
